import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import './EntrepriseQuotes.css';

const API_URL = import.meta.env.VITE_API_URL;

const EntrepriseComplaints = () => {
    const [reclamations, setReclamations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({
        sujet: '',
        message: ''
    });

    useEffect(() => {
        fetchReclamations();
    }, []);

    const fetchReclamations = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_URL}/reclamations/mes-reclamations`, {
                headers: {Authorization: `Bearer ${token}`}
            });
            setReclamations(response.data || []);
        } catch (error) {
            console.error('Erreur réclamations:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${API_URL}/reclamations`, formData, {
                headers: {Authorization: `Bearer ${token}`}
            });
            Swal.fire({
                icon: 'success',
                title: 'Ticket ouvert',
                text: 'Votre demande a été transmise au support technique B2B.',
                confirmButtonColor: '#3b82f6'
            });
            setShowForm(false);
            setFormData({sujet: '', message: ''});
            fetchReclamations();
        } catch (error) {
            Swal.fire('Erreur', 'Impossible d\'envoyer la réclamation.', 'error');
        }
    };

    if (showForm) {
        return (
            <div className="quote-form-container">
                <div className="form-header-simple">
                    <button onClick={() => setShowForm(false)} className="back-link">← Retour</button>
                    <h3>Nouveau Ticket de Support</h3>
                </div>
                <form onSubmit={handleSubmit} className="premium-form">
                    <div className="field-group">
                        <label>Sujet de l'intervention</label>
                        <input
                            type="text"
                            value={formData.sujet}
                            onChange={(e) => setFormData({...formData, sujet: e.target.value})}
                            required
                            placeholder="Ex: Problème onduleur, Retard livraison..."
                        />
                    </div>
                    <div className="field-group" style={{marginTop: '20px'}}>
                        <label>Description détaillée</label>
                        <textarea
                            value={formData.message}
                            onChange={(e) => setFormData({...formData, message: e.target.value})}
                            required
                            rows="5"
                            placeholder="Décrivez précisément votre problème..."
                        ></textarea>
                    </div>
                    <div className="form-actions-simple">
                        <button type="submit" className="submit-btn-simple">Ouvrir le ticket</button>
                        <button type="button" className="cancel-btn-simple" onClick={() => setShowForm(false)}>Annuler</button>
                    </div>
                </form>
            </div>
        );
    }

    return (
        <div className="entreprise-quotes-container">
            <div className="header-with-action">
                <div>
                    <h2>Support & Réclamations</h2>
                    <p>Suivez l'état de vos demandes d'assistance technique.</p>
                </div>
                <button className="add-quote-btn" onClick={() => setShowForm(true)}>
                    + Nouveau Ticket
                </button>
            </div>

            {loading ? (
                <LoadingSpinner />
            ) : reclamations.length === 0 ? (
                <div className="empty-state">
                    <span className="empty-icon">🎧</span>
                    <h3>Tout est en ordre</h3>
                    <p>Vous n'avez aucune réclamation en cours.</p>
                </div>
            ) : (
                <div className="quotes-grid">
                    {reclamations.map((rec) => (
                        <div key={rec._id} className="quote-card">
                            <div className="quote-card-header">
                                <span className={`status-badge ${rec.statut === 'résolu' ? 'success' : 'warning'}`}>
                                    {rec.statut || 'En étude'}
                                </span>
                                <span className="quote-date">{new Date(rec.createdAt).toLocaleDateString()}</span>
                            </div>
                            <div className="quote-main-info">
                                <h4 style={{color: 'white', marginBottom: '10px'}}>{rec.sujet}</h4>
                                <p style={{color: '#94a3b8', fontSize: '0.9rem'}}>{rec.message}</p>
                            </div>
                            {rec.reponseAdmin && (
                                <div className="quote-specs" style={{borderLeft: '4px solid #3b82f6'}}>
                                    <span style={{color: '#3b82f6', fontWeight: 800, fontSize: '0.7rem', display: 'block', marginBottom: '5px'}}>RÉPONSE SUPPORT:</span>
                                    <p style={{color: '#f1f5f9', fontSize: '0.85rem'}}>{rec.reponseAdmin}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default EntrepriseComplaints;
